import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'kt-input-separator',
    templateUrl: './separator.component.html',
    styleUrls: ['./separator.component.scss']
})
export class SeparatorComponent implements OnInit {
    @Input() fieldObj: any;
    constructor() { }

    ngOnInit() {
    }

}
